module.exports = __webpack_public_path__ + "img/34-Hyperpigmentation.e90120df.png";